import {TableCell, TableRow} from "@material-ui/core";
import _ from "lodash";
import React from "react";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  inheritFontWeight: {
    fontWeight: 'inherit',
  }
}));


const keys = [
  {id: 'contact_passed_industry_exam_id', name: 'contact_passed_industry_exam_id'},
  {id: 'contact_passed_industry_exam_date', name: 'contact_passed_industry_exam_date'},
  {id: 'contact_passed_industry_exam_name', name: 'contact_passed_industry_exam_name'},
]

const DesignationsRow = (props) => {
  const {designations} = props;
  const classes = useStyles();

  return (
    designations.map(((designation, index) =>
        <TableRow hover key={`${designation.attributes.registerations_regulator}-${index}`}>
          {keys.map(((key) =>
              <TableCell key={`${key.name}-${designation.attributes.registerations_regulator}`} className={classes.inheritFontWeight}>
                {_.isNil(designation.attributes[key.id]) ? '' : `${designation.attributes[key.id]}`}
              </TableCell>
          ))}
        </TableRow>
    ))
  )
}

export default DesignationsRow;